module.exports = __webpack_public_path__ + "img/11-small.0c1b648f.png";